import { __assign, __rest } from "tslib";
import React from "react";
import { Avatar as CustomAvatar } from "./styles";
export var Avatar = function (_a) {
    var fullName = _a.fullName, profileImageUrl = _a.profileImageUrl, rest = __rest(_a, ["fullName", "profileImageUrl"]);
    var title = (fullName === null || fullName === void 0 ? void 0 : fullName.split(" ").filter(function (x) { return x; }).map(function (i) { return i[0].toUpperCase(); }).join("")) || "A";
    return (React.createElement(CustomAvatar, __assign({ alt: fullName, width: 32, height: 32 }, { src: profileImageUrl !== null && profileImageUrl !== void 0 ? profileImageUrl : "" }, rest), title));
};
//# sourceMappingURL=Avatar.js.map